import { configureTelemetry } from '@ms/yammer-data/dist/telemetry';
import getClientContext from '@ms/yammer-web-support/dist/clientContext';
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

import config from '../../config';

export const configure = async () => {
  configureTelemetry({
    config,
    hostingConfig: readHostingConfiguration(),
    skipNextCleanup: true,
    registerUnhandledEventsListener: true,
    isMsal: true,
    clientContext: getClientContext(),
    skipResourceTimingReportForExternalJavascript: true,
  });
};
